function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.5 0H6.5A6.5 6.5 0 000 6.5v39.981a6.5 6.5 0 006.5 6.5h163a6.5 6.5 0 006.5-6.5V6.5a6.5 6.5 0 00-6.5-6.5z",
  fill: "#000"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.834 28.808c-3.056.015-5.524 2.542-5.514 5.647.01 3.106 2.493 5.617 5.55 5.612 3.056-.005 5.531-2.524 5.531-5.63a5.596 5.596 0 00-1.608-4.013 5.418 5.418 0 00-3.959-1.616zm0 9.047a3.356 3.356 0 01-3.27-1.936 3.459 3.459 0 01.573-3.8 3.327 3.327 0 013.69-.855 3.417 3.417 0 012.136 3.174 3.29 3.29 0 01-.855 2.379 3.185 3.185 0 01-2.274 1.038zm-12.137-9.046c-3.058.007-5.533 2.53-5.528 5.638.005 3.107 2.487 5.622 5.545 5.62 3.059-.002 5.537-2.522 5.537-5.63a5.596 5.596 0 00-1.609-4.013 5.418 5.418 0 00-3.958-1.616h.013zm0 9.046a3.355 3.355 0 01-3.278-1.926 3.46 3.46 0 01.563-3.804 3.327 3.327 0 013.69-.861 3.417 3.417 0 012.14 3.174 3.289 3.289 0 01-.854 2.379 3.184 3.184 0 01-2.274 1.038h.013zm-14.458-7.311v2.384h5.632a5.032 5.032 0 01-1.304 3.007 5.715 5.715 0 01-4.341 1.748c-3.456 0-6.258-2.847-6.258-6.358 0-3.511 2.802-6.358 6.258-6.358a5.946 5.946 0 014.263 1.709l1.656-1.682a8.135 8.135 0 00-5.906-2.477c-3.156-.125-6.127 1.515-7.742 4.273a8.875 8.875 0 000 8.951c1.615 2.758 4.586 4.398 7.742 4.273a7.758 7.758 0 006.01-2.45 8.022 8.022 0 002.034-5.59 7.89 7.89 0 00-.13-1.497l-7.914.067zm59.071 1.854c-.696-2.08-2.584-3.509-4.746-3.59a5.174 5.174 0 00-3.807 1.668 5.349 5.349 0 00-1.408 3.962 5.556 5.556 0 001.574 4.002 5.381 5.381 0 003.928 1.627 5.492 5.492 0 004.615-2.49l-1.89-1.325a3.158 3.158 0 01-2.725 1.563 2.813 2.813 0 01-2.686-1.708l7.418-3.113-.273-.596zm-7.562 1.88a3.12 3.12 0 01.768-2.26 3.02 3.02 0 012.126-1.024 2.144 2.144 0 012.06 1.192l-4.954 2.093zm-6.023 5.458h2.438V23.179h-2.438v16.557zm-3.989-9.67h-.092a3.883 3.883 0 00-2.92-1.324c-2.959.146-5.285 2.626-5.285 5.636 0 3.01 2.326 5.49 5.285 5.636a3.753 3.753 0 002.92-1.325h.079v.808c0 2.16-1.135 3.312-2.96 3.312a3.067 3.067 0 01-2.79-2l-2.125.9c.819 2.023 2.763 3.338 4.915 3.325 2.855 0 5.215-1.709 5.215-5.868V29.14h-2.242v.927zm-2.79 7.789c-1.743-.156-3.08-1.64-3.08-3.417 0-1.778 1.337-3.262 3.08-3.418a3.113 3.113 0 012.189 1.075c.557.644.835 1.488.77 2.343a3.186 3.186 0 01-.766 2.354 3.085 3.085 0 01-2.206 1.063h.013zm31.784-14.676h-5.827v16.557h2.437v-6.278h3.403A5.05 5.05 0 00137.437 31a5.225 5.225 0 000-5.365 5.05 5.05 0 00-4.694-2.457h-.013zm0 7.947h-3.403v-5.642h3.455c1.545 0 2.797 1.272 2.797 2.841 0 1.57-1.252 2.841-2.797 2.841l-.052-.04zm15.032-2.384a4.552 4.552 0 00-4.342 2.53l2.165.914a2.299 2.299 0 012.216-1.218 2.322 2.322 0 011.744.51c.49.401.801.986.863 1.622v.172a5.316 5.316 0 00-2.542-.636c-2.334 0-4.693 1.325-4.693 3.722a3.85 3.85 0 001.263 2.689 3.73 3.73 0 002.778.954 3.411 3.411 0 003.129-1.59h.078v1.325h2.347v-6.371c0-2.9-2.164-4.583-4.941-4.583l-.065-.04zm-.3 9.073c-.795 0-1.903-.41-1.903-1.404 0-1.324 1.381-1.761 2.607-1.761.774-.02 1.54.172 2.216.556-.168 1.483-1.386 2.613-2.855 2.649l-.065-.04zm13.858-8.675l-2.79 7.179h-.078l-2.894-7.18h-2.607l4.341 10.04-2.477 5.577h2.542l6.675-15.616h-2.712zm-21.915 10.596h2.438V23.179h-2.438v16.557z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.822 13.563a3.622 3.622 0 01-.978 2.65 3.763 3.763 0 01-2.868 1.178 4.108 4.108 0 01-3.766-2.584 4.221 4.221 0 01.884-4.529 3.88 3.88 0 012.882-1.192 3.987 3.987 0 011.603.331c.472.194.892.498 1.226.888l-.691.702a2.59 2.59 0 00-2.138-.94 3.001 3.001 0 00-2.185.932 3.1 3.1 0 00-.853 2.246 3.129 3.129 0 001.855 2.913 3.04 3.04 0 003.36-.621 2.524 2.524 0 00.652-1.616h-2.83v-.954h3.794c.035.197.053.396.053.596zm5.97-3.311h-3.52v2.516h3.208v.954h-3.208v2.517h3.52v.98H63.23V9.272h4.563v.98zm4.277 6.967h-1.004v-6.967h-2.19v-.98h5.436v.98H72.07v6.967zm6.075 0V9.272h1.004v7.947h-1.004zm5.462 0h-1.003v-6.967h-2.19v-.98h5.37v.98h-2.177v6.967zm12.36-1.033a4.022 4.022 0 01-5.737 0 4.341 4.341 0 010-5.894 4.01 4.01 0 012.868-1.214 4.01 4.01 0 012.869 1.214 4.328 4.328 0 010 5.894zm-4.994-.662a2.978 2.978 0 004.25 0 3.431 3.431 0 000-4.557 2.978 2.978 0 00-4.25 0 3.43 3.43 0 000 4.556zm7.562 1.695V9.272h1.225l3.807 6.185V9.272h1.004v7.947h-1.043l-3.976-6.477v6.477h-1.017z",
  fill: "#fff",
  stroke: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.61 9.987a2.677 2.677 0 00-.599 1.854V41.14c-.04.673.175 1.336.6 1.854l.091.093 16.153-16.398v-.384L13.702 9.895l-.091.092z",
  fill: "url(#playstore_svg__paint0_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.2 32.16l-5.345-5.47v-.385l5.345-5.483.117.066 6.402 3.695c1.825 1.047 1.825 2.769 0 3.828l-6.376 3.682-.143.067z",
  fill: "url(#playstore_svg__paint1_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.356 32.08l-5.501-5.59L13.61 42.995a2.1 2.1 0 002.711.08L35.37 32.08",
  fill: "url(#playstore_svg__paint2_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.356 20.901L16.31 9.907a2.1 2.1 0 00-2.711.08l16.257 16.504 5.501-5.59z",
  fill: "url(#playstore_svg__paint3_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M35.2 31.96L16.31 42.889a2.15 2.15 0 01-2.608 0l-.091.093.091.093a2.137 2.137 0 002.607 0L35.356 32.08l-.156-.12z",
  fill: "#000"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.12,
  d: "M13.61 42.809a2.677 2.677 0 01-.599-1.855v.2c-.04.672.175 1.335.6 1.853l.091-.092-.091-.106zM41.72 28.213L35.2 31.96l.117.12 6.402-3.683a2.317 2.317 0 001.303-1.907 2.459 2.459 0 01-1.303 1.721z",
  fill: "#000"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M16.31 10.093l25.409 14.676a2.458 2.458 0 011.303 1.722 2.317 2.317 0 00-1.303-1.908L16.308 9.907c-1.825-1.046-3.311-.172-3.311 1.948v.198c.039-2.132 1.5-3.006 3.311-1.96z",
  fill: "#fff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "playstore_svg__paint0_linear",
  x1: 23.232,
  y1: 11.537,
  x2: 9.347,
  y2: 25.643,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#00A0FF"
}), React.createElement("stop", {
  offset: 0.01,
  stopColor: "#00A1FF"
}), React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), React.createElement("stop", {
  offset: 0.51,
  stopColor: "#00D2FF"
}), React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), React.createElement("linearGradient", {
  id: "playstore_svg__paint1_linear",
  x1: 44.104,
  y1: 26.491,
  x2: 12.568,
  y2: 26.491,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFE000"
}), React.createElement("stop", {
  offset: 0.41,
  stopColor: "#FFBD00"
}), React.createElement("stop", {
  offset: 0.78,
  stopColor: "orange"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), React.createElement("linearGradient", {
  id: "playstore_svg__paint2_linear",
  x1: 32.371,
  y1: 31.653,
  x2: 8.523,
  y2: 55.872,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF3A44"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), React.createElement("linearGradient", {
  id: "playstore_svg__paint3_linear",
  x1: 9.517,
  y1: 7.094,
  x2: 20.162,
  y2: 17.909,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#32A071"
}), React.createElement("stop", {
  offset: 0.07,
  stopColor: "#2DA771"
}), React.createElement("stop", {
  offset: 0.48,
  stopColor: "#15CF74"
}), React.createElement("stop", {
  offset: 0.8,
  stopColor: "#06E775"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})));

const SvgPlaystore = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 176,
  height: 53,
  viewBox: "0 0 176 53",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPlaystore, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;